import moment from 'moment';
import isNumeric from 'utils/isNumeric';

const getMoment = date => date && (isNumeric(date) ? moment.unix(date) : moment(date));
export default getMoment;
